import { render, staticRenderFns } from "./AdminSiteConfig.vue?vue&type=template&id=56e34597&scoped=true"
import script from "./AdminSiteConfig.vue?vue&type=script&lang=js"
export * from "./AdminSiteConfig.vue?vue&type=script&lang=js"
import style0 from "./AdminSiteConfig.vue?vue&type=style&index=0&id=56e34597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e34597",
  null
  
)

export default component.exports